// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bfb_a bfq_h","Menu__offsetParent":"bfb_b bfq_bj","Menu__trigger--shadowed":"bfb_c"};